import axiosIns from '@/libs/axios'

const ROOT_URL = '/core/user-types'
export default {
  namespaced: true,
  state: {
    dataList: [],
    metaData: {
      total: 0,
      page: 1,
      limit: 20,
      totalPages: 0,
    },
    dataItem: {
      id: null,
      title: null,
      role: null,
      user_type_ability: [],
      typeAbilities: [],
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    metaData(state) {
      return state.metaData
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_META_DATA(state, data) {
      state.metaData = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        title: null,
        role: null,
        user_type_ability: [],
        typeAbilities: [],
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      axiosIns
        .post(ROOT_URL, params)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_META_DATA', response.data.meta)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, params) {
      axiosIns
        .post(`${ROOT_URL}/view`, params)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      axiosIns
        .post(`${ROOT_URL}/create`, postData)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    updateData({ commit }, postData) {
      axiosIns
        .post(`${ROOT_URL}/update`, postData)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/delete`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
